/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "jučer",
        "-2": "prekjučer",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} dana",
          "one": "za {0} dan",
          "other": "za {0} dana"
        },
        "past": {
          "few": "prije {0} dana",
          "one": "prije {0} dan",
          "other": "prije {0} dana"
        }
      },
      "day-narrow": {
        "-1": "jučer",
        "-2": "prekjučer",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} d.",
          "one": "za {0} d.",
          "other": "za {0} d."
        },
        "past": {
          "few": "prije {0} d.",
          "one": "prije {0} d.",
          "other": "prije {0} d."
        }
      },
      "day-short": {
        "-1": "jučer",
        "-2": "prekjučer",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} d.",
          "one": "za {0} d.",
          "other": "za {0} d."
        },
        "past": {
          "few": "prije {0} d.",
          "one": "prije {0} d.",
          "other": "prije {0} d."
        }
      },
      "hour": {
        "0": "ovaj sat",
        "future": {
          "few": "za {0} sata",
          "one": "za {0} sat",
          "other": "za {0} sati"
        },
        "past": {
          "few": "prije {0} sata",
          "one": "prije {0} sat",
          "other": "prije {0} sati"
        }
      },
      "hour-narrow": {
        "0": "ovaj sat",
        "future": {
          "few": "za {0} sata",
          "one": "za {0} sat",
          "other": "za {0} sati"
        },
        "past": {
          "few": "prije {0} sata",
          "one": "prije {0} sat",
          "other": "prije {0} sati"
        }
      },
      "hour-short": {
        "0": "ovaj sat",
        "future": {
          "few": "za {0} sata",
          "one": "za {0} sat",
          "other": "za {0} sati"
        },
        "past": {
          "few": "prije {0} sata",
          "one": "prije {0} sat",
          "other": "prije {0} sati"
        }
      },
      "minute": {
        "0": "ova minuta",
        "future": {
          "few": "za {0} minute",
          "one": "za {0} minutu",
          "other": "za {0} minuta"
        },
        "past": {
          "few": "prije {0} minute",
          "one": "prije {0} minutu",
          "other": "prije {0} minuta"
        }
      },
      "minute-narrow": {
        "0": "ova minuta",
        "future": {
          "few": "za {0} min.",
          "one": "za {0} min.",
          "other": "za {0} min."
        },
        "past": {
          "few": "prije {0} min.",
          "one": "prije {0} min.",
          "other": "prije {0} min."
        }
      },
      "minute-short": {
        "0": "ova minuta",
        "future": {
          "few": "za {0} min.",
          "one": "za {0} min.",
          "other": "za {0} min."
        },
        "past": {
          "few": "prije {0} min.",
          "one": "prije {0} min.",
          "other": "prije {0} min."
        }
      },
      "month": {
        "-1": "prošli mjesec",
        "0": "ovaj mjesec",
        "1": "sljedeći mjesec",
        "future": {
          "few": "za {0} mjeseca",
          "one": "za {0} mjesec",
          "other": "za {0} mjeseci"
        },
        "past": {
          "few": "prije {0} mjeseca",
          "one": "prije {0} mjesec",
          "other": "prije {0} mjeseci"
        }
      },
      "month-narrow": {
        "-1": "prošli mjesec",
        "0": "ovaj mjesec",
        "1": "sljedeći mjesec",
        "future": {
          "few": "za {0} mj.",
          "one": "za {0} mj.",
          "other": "za {0} mj."
        },
        "past": {
          "few": "prije {0} mj.",
          "one": "prije {0} mj.",
          "other": "prije {0} mj."
        }
      },
      "month-short": {
        "-1": "prošli mjesec",
        "0": "ovaj mjesec",
        "1": "sljedeći mjesec",
        "future": {
          "few": "za {0} mj.",
          "one": "za {0} mj.",
          "other": "za {0} mj."
        },
        "past": {
          "few": "prije {0} mj.",
          "one": "prije {0} mj.",
          "other": "prije {0} mj."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "posljednji kvartal",
        "0": "ovaj kvartal",
        "1": "sljedeći kvartal",
        "future": {
          "few": "za {0} kvartala",
          "one": "za {0} kvartal",
          "other": "za {0} kvartala"
        },
        "past": {
          "few": "prije {0} kvartala",
          "one": "prije {0} kvartala",
          "other": "prije {0} kvartala"
        }
      },
      "quarter-narrow": {
        "-1": "posljednji kvartal",
        "0": "ovaj kvartal",
        "1": "sljedeći kvartal",
        "future": {
          "few": "za {0} kv.",
          "one": "za {0} kv.",
          "other": "za {0} kv."
        },
        "past": {
          "few": "prije {0} kv.",
          "one": "prije {0} kv.",
          "other": "prije {0} kv."
        }
      },
      "quarter-short": {
        "-1": "posljednji kvartal",
        "0": "ovaj kvartal",
        "1": "sljedeći kvartal",
        "future": {
          "few": "za {0} kv.",
          "one": "za {0} kv.",
          "other": "za {0} kv."
        },
        "past": {
          "few": "prije {0} kv.",
          "one": "prije {0} kv.",
          "other": "prije {0} kv."
        }
      },
      "second": {
        "0": "sada",
        "future": {
          "few": "za {0} sekunde",
          "one": "za {0} sekundu",
          "other": "za {0} sekundi"
        },
        "past": {
          "few": "prije {0} sekunde",
          "one": "prije {0} sekundu",
          "other": "prije {0} sekundi"
        }
      },
      "second-narrow": {
        "0": "sada",
        "future": {
          "few": "za {0} sek.",
          "one": "za {0} sek.",
          "other": "za {0} sek."
        },
        "past": {
          "few": "prije {0} sek.",
          "one": "prije {0} sek.",
          "other": "prije {0} sek."
        }
      },
      "second-short": {
        "0": "sada",
        "future": {
          "few": "za {0} sek.",
          "one": "za {0} sek.",
          "other": "za {0} sek."
        },
        "past": {
          "few": "prije {0} sek.",
          "one": "prije {0} sek.",
          "other": "prije {0} sek."
        }
      },
      "week": {
        "-1": "prošle sedmice",
        "0": "ove sedmice",
        "1": "sljedeće sedmice",
        "future": {
          "few": "za {0} sedmice",
          "one": "za {0} sedmicu",
          "other": "za {0} sedmica"
        },
        "past": {
          "few": "prije {0} sedmice",
          "one": "prije {0} sedmicu",
          "other": "prije {0} sedmica"
        }
      },
      "week-narrow": {
        "-1": "prošle sedmice",
        "0": "ove sedmice",
        "1": "sljedeće sedmice",
        "future": {
          "few": "za {0} sed.",
          "one": "za {0} sed.",
          "other": "za {0} sed."
        },
        "past": {
          "few": "prije {0} sed.",
          "one": "prije {0} sed.",
          "other": "prije {0} sed."
        }
      },
      "week-short": {
        "-1": "prošle sedmice",
        "0": "ove sedmice",
        "1": "sljedeće sedmice",
        "future": {
          "few": "za {0} sed.",
          "one": "za {0} sed.",
          "other": "za {0} sed."
        },
        "past": {
          "few": "prije {0} sed.",
          "one": "prije {0} sed.",
          "other": "prije {0} sed."
        }
      },
      "year": {
        "-1": "prošle godine",
        "0": "ove godine",
        "1": "sljedeće godine",
        "future": {
          "few": "za {0} godine",
          "one": "za {0} godinu",
          "other": "za {0} godina"
        },
        "past": {
          "few": "prije {0} godine",
          "one": "prije {0} godinu",
          "other": "prije {0} godina"
        }
      },
      "year-narrow": {
        "-1": "prošle godine",
        "0": "ove godine",
        "1": "sljedeće godine",
        "future": {
          "few": "za {0} g.",
          "one": "za {0} g.",
          "other": "za {0} g."
        },
        "past": {
          "few": "prije {0} g.",
          "one": "prije {0} g.",
          "other": "prije {0} g."
        }
      },
      "year-short": {
        "-1": "prošle godine",
        "0": "ove godine",
        "1": "sljedeće godine",
        "future": {
          "few": "za {0} god.",
          "one": "za {0} god.",
          "other": "za {0} god."
        },
        "past": {
          "few": "prije {0} god.",
          "one": "prije {0} god.",
          "other": "prije {0} god."
        }
      }
    },
    "locale": "bs"
  });
}